import {type ElementPosition} from './get-element-position';

export function scaleElement(pos: ElementPosition, width: number | undefined, height: number | undefined): ElementPosition {
  const updated = {...pos};

  if (width != null) {
    updated.width = width;
    updated.right = pos.left + width;
  }

  if (height != null) {
    updated.height = height;
    updated.bottom = pos.top + height;
  }

  return updated;
}
